/**
 * @module tree/teleport
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import manager from '../contracts/manager.js'
import object from '../utils/object.js'
import after from './after.js'
import append from './append.js'
import before from './before.js'
import prepend from './prepend.js'
import replace from './replaceWith.js'
import one from '../selectors/one.js'
import body from './body.js'

const methods = object(null, {
  after,
  append,
  before,
  prepend,
  replace
})

const keys = Object.keys(methods)

/**
 * @todo document?
 */
export default async (
  target,
  destination = target.ownerDocument
) => {
  const element = target.nodeName.toLowerCase() === 'template'
    ? one('*', target.content)
    : target

  for (const key of keys) {
    const method = methods[key]
    const selector = target.getAttribute(`data-${key}`)

    if (selector) {
      const container = one(selector, destination)
      const wrapper = body()

      append(wrapper, element)
      await manager.trigger(wrapper)
      method(container, element)

      return element
    }
  }
}
